/**
 * Handles the error.
 *
 * @param  {Object} config: configuration of the AJAX request.
 * @param  {Function} callback: (optional) function to call over the error.
 * @throws {Error} with the URL of the failed request.
 * @return {Function}
 */
export default function onError(config, callback) {
  const hasCallback = typeof callback === 'function';
  return (e) => {
    const error = e || new Error();
    error.message = `Request failed: ${config.url}`;
    if (hasCallback) return callback(error);
    throw error;
  };
}
